import { createSlice } from "@reduxjs/toolkit";
import { boardViewForAllocation } from "./TransferOrderSliceV2";
import { sortAllView } from "../utils";

const taxDefaultColumns = [
  "TAX CATEGORY",
  "NAME",
  "RATE",
  "JURISDICTION",
  "CREATED BY",
  "CREATE DATE",
  "SYSTEM DEFAULT",
];

const taxCategoryDefaultColumns = [
  "TAX CATEGORY NAME",
  "TAX CATEGORY DESCRIPTION",
  "SYSTEM DEFAULT",
];

const productTaxClassificationDefaultColumns = [
  "PRODUCT TAX CLASSIFICATION NAME",
  "DESCRIPTION",
  "SYSTEM DEFAULT",
];

const initialState = {
  taxRate: { count: 0, results: [] },
  taxRateParams: { limit: 10, offset: 0 },
  taxRateSelection: [],
  taxJurisdictionSelection: [],

  taxRateLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: taxDefaultColumns,
      allViews: {
        "Default View": taxDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  taxCategory: { count: 0, results: [] },
  taxCategoryParams: { limit: 10, offset: 0 },
  taxCategorySelection: [],
  taxCategoryLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: taxCategoryDefaultColumns,
      allViews: {
        "Default View": taxCategoryDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  productTaxClassification: { count: 0, results: [] },
  productTaxClassificationParams: { limit: 10, offset: 0 },
  productTaxClassificationSelection: [],
  productTaxClassificationLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: productTaxClassificationDefaultColumns,
      allViews: {
        "Default View": productTaxClassificationDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },
};

const taxSlice = createSlice({
  name: "tax",
  initialState,
  reducers: {
    setTaxes: (state, action) => {
      state.taxRate = action.payload;
    },
    setTaxesSelection: (state, action) => {
      state.taxRateSelection = action.payload;
    },
    setTaxCategories: (state, action) => {
      state.taxCategory = action.payload;
    },
    setTaxCategorySelection: (state, action) => {
      state.taxCategorySelection = action.payload;
    },
    setProductTaxClassifications: (state, action) => {
      state.productTaxClassification = action.payload;
    },
    setProductTaxClassificationSelection: (state, action) => {
      state.productTaxClassificationSelection = action.payload;
    },
    setTaxJurisdictionSelection: (state, action) => {
      state.taxJurisdictionSelection = action.payload;
    },

    setTaxLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.taxRateLayout = {
        ...state.taxRateLayout,
        listView: {
          ...state.taxRateLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.taxRateLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setTaxCategoryLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.taxCategoryLayout = {
        ...state.taxCategoryLayout,
        listView: {
          ...state.taxCategoryLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.taxCategoryLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setProductTaxClassificationLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.productTaxClassificationLayout = {
        ...state.productTaxClassificationLayout,
        listView: {
          ...state.productTaxClassificationLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.productTaxClassificationLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },

    updateTaxParams: (state, action) => {
      state.taxRateParams = { ...state.taxRateParams, ...action.payload };
    },
    updateTaxCategoryParams: (state, action) => {
      state.taxCategoryParams = { ...state.taxCategoryParams, ...action.payload };
    },
    updateProductTaxClassificationParams: (state, action) => {
      state.productTaxClassificationParams = {
        ...state.productTaxClassificationParams,
        ...action.payload,
      };
    },
  },
});

export const {
  setTaxes,
  resetTax,
  resetTaxesSelection,
  setTaxesSelection,
  setTaxCategories,
  setTaxCategorySelection,
  setProductTaxClassifications,
  setProductTaxClassificationSelection,
  setTaxJurisdictionSelection,
  setTaxLayoutAllViews,
  setTaxCategoryLayoutAllViews,
  setProductTaxClassificationLayoutAllViews,
  updateTaxParams,
  updateTaxCategoryParams,
  updateProductTaxClassificationParams,
} = taxSlice.actions;

export default taxSlice.reducer;
